const defaultConfig = {
  itemsKey: "chatbot",
};

export const chatbot = ({ page, config, ...props }) => {
  config = Object.assign({}, defaultConfig, config);

  if (!page || !(config.itemsKey in page) || page[config.itemsKey].length === 0) {
    return null;
  }

  return {
    component: "Chatbot",
    props: {
      chatbot: page.chatbot ?? null,
      ...props,
    },
  };
};
